<template>
  <form @submit.prevent="submit">
    <div class="pb-3">
      <span>{{ $t("global.advanced-auto-scale-disable-note-1") }}</span>
      <strong class="mx-1">{{ $t("global.advanced-auto-scale-disable-note-2") }}</strong>
      <span>{{ $t("global.advanced-auto-scale-disable-note-3") }}</span>
      <a :href="KB_LINK" target="_blank" class="ml-1">{{
        $t("global.advanced-auto-scale-disable-note-4")
      }}</a>
      .
    </div>
    <div class="form-buttons">
      <Btn
        class="mr-2"
        variant="light"
        type="button"
        :disabled="isSubmitting"
        @click="cancel"
        data-test="cancel-disable-site-advanced-auto-scale-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        variant="primary"
        type="submit"
        :disabled="!isSubmittable()"
        :loading="isSubmitting"
        data-test="enable-disable-advanced-auto-scale-button"
      >
        {{ $t("global.turn-off") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import Btn from "@/components/display/Btn";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "SiteDisableAdvancedAutoScaleForm",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
  },
  components: {
    Btn,
  },
  setup(props, { emit, root }) {
    const KB_LINK = "https://help.nexcess.net/client-portal/what-is-advanced-auto-scaling";
    const cancel = () => emit("close");
    const isSubmittable = () => !isSubmitting.value;
    const isSubmitting = ref(false);

    const submit = () => {
      isSubmitting.value = true;
      const name = props.plan.isTShirt ? props.plan.nickname : props.site.domain;
      store
        .dispatch("sites/disableAdvancedAutoScale", { id: props.site.id })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.advanced-auto-scale-disabling-message", { name }),
          });
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.advanced-auto-scale-disable-error-message", { name }),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      cancel,
      isSubmittable,
      isSubmitting,
      KB_LINK,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
</style>
